import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./../context/AuthContent";
import {
  getLocalCart,
  increaseQty,
  decreaseQty,
  deleteCartItem,
  getCheckoutRedirectPath,
} from "./../config/commonfunctions/AddToCart";
import "./../css/cart.css";
import EmptyCart from "./Components/EmptyCart";
import ImageSetter from "./Components/ImageSetter";
import { getProductDetailsForCart } from "./../api/index";
import LoaderComponent from "./../components/Loader/LoaderComponent";

export default function Cart() {
  const navigate = useNavigate();
  const { refreshCartCount } = useAuth();

  // TEMP: replace with API / context / redux
  const [loading, setLoading] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [productid, setProductId] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    setLoading(true);
    const loadCart = async () => {
      const CartWhole = await getLocalCart();
      // console.log("CartWhole", CartWhole);
      setCartItems(CartWhole.cart.items);
      const productsIds = CartWhole.cart.items.map((item) => item.product_id);
      setProductId(productsIds);
    };

    loadCart();
  }, []);

  useEffect(() => {
    async function fetchCartProducts() {
      try {
        const res = await getProductDetailsForCart(productid);
        setProducts(res.data.ProductsDetails);
      } catch (err) {
        console.error(err);
      }
    }

    fetchCartProducts();
    setLoading(false);
  }, [productid]);

  // console.log("cartItems", loading, cartItems, products);

  const totalAmount =
    cartItems &&
    cartItems.reduce((total, item) => total + item.price * item.quantity, 0);

  return (
    <div className="cart-container">
      {loading ? (
        <LoaderComponent />
      ) : cartItems.length === 0 ? (
        <EmptyCart />
      ) : (
        <React.Fragment>
          <div className="cart-items">
            {cartItems.map((item) => {
              const Product =
                products.length > 0 &&
                products.find((pro) => pro.id == item.product_id);

              return (
                <div className="cart-item" key={item.id}>
                  {products.length > 0 && (
                    <ImageSetter
                      staticfolder={"shop_product_listing"}
                      image={Product.product_images}
                      name={Product.product_name}
                      size={"small"}
                    />
                  )}
                  <div className="item-details">
                    <h4 className="cart-product-name">
                      {Product.product_name}
                    </h4>
                    <p>₹{Number(item.price).toFixed(0)}</p>

                    <div className="qty-controls">
                      <button
                        className="btn btn-small btn-danger"
                        onClick={async () => {
                          const updatedItems = await decreaseQty(
                            Product.id,
                            item.quantity,
                          );
                          await refreshCartCount();
                          setCartItems(updatedItems);
                        }}
                      >
                        -
                      </button>
                      <span>{item.quantity}</span>
                      <button
                        className="btn btn-small btn-success"
                        onClick={async () => {
                          const updatedItems = await increaseQty(
                            Product.id,
                            item.quantity,
                          );
                          await refreshCartCount();
                          setCartItems(updatedItems);
                        }}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="item-actions">
                    <button
                      className="btn btn-danger text-right"
                      onClick={async () => {
                        const updatedItems = await deleteCartItem(Product.id);
                        console.log(updatedItems);
                        // PASS ITEMS MOST IMPORTANT AT EVERY POINT
                        await refreshCartCount();
                        if (updatedItems) {
                          setCartItems(updatedItems.cart.items);
                        } else {
                          setCartItems([]);
                        }
                      }}
                    >
                      Remove
                    </button>
                    <div className="final-price-against-item">
                      <p>₹{item.price * item.quantity}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cart-summary">
            <h3>Order Summary</h3>
            <div className="summary-row">
              <span>Total</span>
              <span>₹{totalAmount}</span>
            </div>

            <button
              className="checkout-btn"
              onClick={() => navigate(getCheckoutRedirectPath())}
            >
              Proceed to Checkout
            </button>
          </div>
        </React.Fragment>
      )}
    </div>
  );
}
